import React, {useEffect, useState, useRef} from "react";
import {moveTrimPoint} from "./utils/utils";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ErrorSnackBar from "./CommonComponents/ErrorSnackBar/ErrorSnackBar";
import {useTheme} from "../../contexts/theme";
import KeyMomentWindowsPlayer from "./KeyMomentWindowsPlayer";
import KeyMomentVideoPlayerBar from "./KeyMomentVideoPlayerBar";
import KeyMomentVideoPlayerControls from "./KeyMomentVideoPlayerControls";
import {formatUTCDate} from "./utils/utils";
import KeyMomentViewer from "./KeyMomentViewer";
import Grid from "@mui/material/Grid";
import TrimPointsFields from "./TrimPointsFields";
import 'video.js/dist/video-js.css';
import ClipForm from "../ClipsComponents/ClipForm/ClipForm";
import {defaultFormClip} from "../../utils/constants";
import {createClip} from "../../queries/clipQueries";
const aspectRatio = {
    label : '16:9',
    numeric : 16/9,
    disabled : true
}
//LoadFormOptions è opzionale e va specificato solo se devi usare il form delle clip, passa una funzione vuota altrimenti
export default function KeyMomentEditor({ dispose, live, event, onDownload, onClipComputation, loadClips, axiosInstance, loadFormOptions}) {
    const theme = useTheme();

    const [videoTime, setVideoTime] = React.useState(0);
    const [videoDuration, setVideoDuration] = React.useState(0);
    const [trimPoints, setTrimPoints] = React.useState([]);
    const [isActiveTime, setIsActiveTime] = React.useState(false);
    const [changeVideoTime, setChangeVideoTime] = React.useState(0);
    const [isPlaying, setIsPlaying] = React.useState(false);
    const [muted, setMuted] = React.useState(true);
    const [clips, setClips] = React.useState([]);
    const [clipSelected, setClipSelect] = useState(undefined);
    const [currentFocus, setCurrentFocus] = React.useState({type: '', index: -1});
    const [isGrabberDragging, setIsGrabberDragging] = React.useState(false);
    const [jobId, setJobId] = React.useState("");
    const trimPointsRef = React.useRef([]);
    const videoDurationRef = React.useRef(0);
    const [loadError, setLoadError] = useState({message: '', error: false});
    const [eventStream, setEventStream] = useState({expiring_at:'', m3u8_signed_url:''})

    const [formClip, setFormClip] = React.useState(defaultFormClip);
    const [teamOptions, setTeamOptions] = React.useState([]);
    const [periodOptions, setPeriodOptions] = React.useState([]);
    const [keyMomentOptions, setKeyMomentOptions] = React.useState([]);
    const [clipCreation, setClipCreation] = React.useState(false);

    const playerBoxRef = useRef(null);

    function getFormClip(indexClip){
        const tempFormClip = JSON.parse(JSON.stringify(clips[indexClip]))
        tempFormClip.manual_rating = clips[indexClip].manual_rating ? clips[indexClip].manual_rating : clips[indexClip].auto_rating
        const baseDescr = clips[indexClip].descriptions.find(descr => descr.style === "base_description");
        tempFormClip.description  = baseDescr ? baseDescr.description : ''
        const owngoal = tempFormClip.tags.some(el => el.toLowerCase() === 'owngoal');
        const penalty =tempFormClip.tags.some(el => el.toLowerCase() === 'penalty');
        if (owngoal) {
            tempFormClip.tags = tempFormClip.tags.filter(tag => tag.toLowerCase() !== 'owngoal');
        }
        if (penalty) {
            tempFormClip.tags = tempFormClip.tags.filter(tag => tag.toLowerCase() !== 'penalty');
        }
        tempFormClip.owngoal = owngoal
        tempFormClip.penalty = penalty
        setFormClip(tempFormClip)
    }

    const handleChangeClip = (indexClip) =>{
        if(videoDuration){
            const trimPoint = {
                start : clips[indexClip].stream_time_start !== undefined ? clips[indexClip].stream_time_start : 0,
                end: clips[indexClip].stream_time_end !== undefined ? clips[indexClip].stream_time_end : 0,
            }
            setClipSelect(indexClip);
            const tempTrimPoints = [...trimPoints];
            tempTrimPoints.splice(0,1);
            tempTrimPoints.push(trimPoint);
            updateCurrentTime(trimPoint.start);
            setTrimPoints(tempTrimPoints);
            getFormClip(indexClip)
        }
    }

    async function loadInfo(){
        try{
            const promiseArray = ([loadClips( axiosInstance, event.id ), loadFormOptions(axiosInstance)])
            const responses = await Promise.all(promiseArray);
            return {clips: responses[0], options: responses[1]};
        }catch (error) {
            console.error(error)
            setLoadError({
                message: "Error to fetch clips",
                error: true
            })
        }

    }

    useEffect(() => {
        loadInfo().then(response => {
            if(response) {
                const {clips, options} = response;
                setClips(clips.clip);
                setJobId(clips.job.id);
                setEventStream(clips.eventStream);
                if (event.id){
                    setTeamOptions([event.home_team, event.away_team])
                }
                if (options && options.key_moment_options && options.periods){
                    setKeyMomentOptions(options.key_moment_options)
                    setPeriodOptions(options.periods)
                }
            }else{
                setLoadError({
                    message: "Error to fetch clips",
                    error: true
                })
            }
        })
    }, []);


    function onVideoPlay(){
        if (!isPlaying) {
            if (trimPoints && trimPoints.length > 0) {
                if (Math.floor(trimPoints[0].end) === Math.floor(videoTime)) {
                    updateCurrentTime(trimPoints[0].start)
                }
            }
        }
        setIsPlaying(true);
    }

    function updateCurrentTime(time) {
        setChangeVideoTime(time);
        setVideoTime(time);
    }

    function resetFocus() {
        setCurrentFocus({type: '', index: -1});
    }

    function mergeTrimPoints(index1, index2) {
        const tempTrimPoints = [...trimPointsRef.current];
        if (tempTrimPoints[index1] && tempTrimPoints[index2]) {
            const newTrimPoint = {start: tempTrimPoints[index1].start, end: tempTrimPoints[index2].end};
            tempTrimPoints.splice(index1, 1);
            tempTrimPoints.splice(index2 - 1, 1);
            tempTrimPoints.push(newTrimPoint);
            setTrimPoints(tempTrimPoints);
        }
    }

    function updateTrimPoints(trimPoints, time) {
        setTrimPoints(trimPoints);
        updateCurrentTime(time);
        setIsPlaying(false);
    }

    function moveTrimPoints(amount, direction, index, type, shiftKeyPressed) {
        const tempTrimPoints = [...trimPointsRef.current];
        if (tempTrimPoints[index]) {
            const time = tempTrimPoints[index][type] + (amount * direction);
            moveTrimPoint(tempTrimPoints, time, videoDurationRef.current, index, type, deleteTrimPoint, updateTrimPoints, mergeTrimPoints, {
                use: !shiftKeyPressed,
                shots: []
            });
        }
    }

    async function reset() {
        if (trimPointsRef.current && trimPointsRef.current.length){
            updateCurrentTime(trimPointsRef.current[0].start)
        }else{
            updateCurrentTime(0);
        }
    }


    function deleteTrimPoint(grabberIndex) {
        const tempTrimPoints = [...trimPoints];
        tempTrimPoints.splice(grabberIndex, 1);
        setTrimPoints(tempTrimPoints);
    }

    function getActiveTrimPointIndex(time) {
        for (let i = 0; i < trimPoints.length; i++) {
            const trimPoint = trimPoints[i];
            if (time >= trimPoint.start && time <= trimPoint.end) {
                return i
            }
        }
        return -1
    }

    async function downloadClip() {
        try {
            if (jobId !== "") {
                setLoadError({error: true, message: "Clip Computation Started"})
               const responseLink = await onClipComputation( axiosInstance, jobId, trimPoints[0] );
                if (clipSelected !== undefined){
                    setLoadError({error: true, message: "Your Download will start shortly"})
                    await onDownload(responseLink, clips[clipSelected].title, "16:9")
                }
            }
        } catch (errorDownload) {
            setLoadError({
                error: true,
                message: "Error to download Clip"
            })
        }
    }

    function handleSkip(amount, direction) {
        setVideoTime(prevTime => {
            let time = prevTime + (amount) * direction
            time = time < 0 ? 0 : time;
            time = time > videoDuration ? videoDuration : time;
            setChangeVideoTime(time);
            return time
        });
    }

    function changeFocusNoShortCut() {
        setCurrentFocus({type: 'noShortCut', index: -1})
    }

    useEffect(() => {
        if (isGrabberDragging) {
            setIsActiveTime(true);
        }else if (trimPoints.length === 0) {
            setIsActiveTime(true);
        }
        else {
            if (trimPointsRef.current){
                const activeTrimPointIndex = getActiveTrimPointIndex(videoTime);
                const currentIsActiveTime = activeTrimPointIndex >= 0;
                if(Math.floor(videoTime) === Math.floor(trimPoints[0].end)){
                    setIsPlaying(false);
                }
                setIsActiveTime(currentIsActiveTime)
            }
        }

    }, [videoTime, trimPoints]);

    useEffect(() => {
        trimPointsRef.current = trimPoints;
    }, [trimPoints]);

    const handleChangeTrimPoints = (tp) =>{
        const tempTrimPoints = [...trimPoints]

        if (tempTrimPoints.length > 0) {
            if ((tp.end > tp.start) && (tp.start < videoDuration && tp.start >= 0) && (tp.end < videoDuration && tp.end >= 0)) {
                tempTrimPoints[0].start = tp.start
                tempTrimPoints[0].end = tp.end
                setTrimPoints(tempTrimPoints);
            }
        }else{
            tempTrimPoints.push(
                {
                    start : tp.start,
                    end: tp.end
                }
            )
        }
    }

    const resetTrimPoints = () => {
        setTrimPoints([])
        setClipSelect(undefined)
        setFormClip(defaultFormClip)
    }


    const restoreTrimPoints = () => {
        if (clipSelected !== undefined) {
            if ((clips[clipSelected].stream_time_end > 0) && (clips[clipSelected].stream_time_start > 0)) {
                const tempTrimPoints = [...trimPoints];

                tempTrimPoints[0].start = clips[clipSelected].stream_time_start
                tempTrimPoints[0].end = clips[clipSelected].stream_time_end

                setTrimPoints(tempTrimPoints);
            } else {
                setTrimPoints([])
            }
        }else{
            setTrimPoints([])
        }
    }

    const onSetTrimPointsToVideoTime = (typeTrimPoint) => {
        const tempTrimPoints = [...trimPoints]
        if (tempTrimPoints.length > 0) {
            if (typeTrimPoint === 'start' && (videoTime < trimPoints[0].end)) {
                tempTrimPoints[0].start = videoTime
            } else if (typeTrimPoint === 'end' && (videoTime > trimPoints[0].start)) {
                tempTrimPoints[0].end = videoTime
            }
        }else{
            if (typeTrimPoint === 'start') {
                let start = videoTime;
                let end = videoTime + 60
                if (end > videoDuration){
                    end = videoDuration
                }
                if (start === videoDuration){
                    start = videoDuration - 60
                    end = videoDuration
                }
                tempTrimPoints.push({start, end})
            }else if(typeTrimPoint === 'end') {
                let start = videoTime - 60;
                let end = videoTime
                if (start < 0){
                    start = 0
                }
                if (start === 0){
                    start = 0
                    end = 60
                }
                tempTrimPoints.push({start, end})
            }
        }
        setTrimPoints(tempTrimPoints);
    }

    useEffect(() => {
        videoDurationRef.current = videoDuration;
    }, [videoDuration]);

    function onClipFormFieldChange(field, value){
        setFormClip((prevState) => {
            if (field === 'owngoal' && value){
                return {...prevState, owngoal: value, penalty: false};
            }else if(field === 'penalty' && value){
                return {...prevState, penalty: value, owngoal: false};
            }
            return {...prevState, [field]: value}
        });
    }

    async function onClipFormSubmit(){
        try{
            setClipCreation(true)
            const tempClipForm = JSON.parse(JSON.stringify(formClip));
            tempClipForm.event_id = event.id;
            tempClipForm.job_id = jobId;
            tempClipForm.start_stream = trimPoints[0].start
            tempClipForm.end_stream = trimPoints[0].end
            tempClipForm.duration = trimPoints[0].end - trimPoints[0].start
            if (tempClipForm.owngoal){
                tempClipForm.tags.push("OwnGoal")
            }
            if (tempClipForm.penalty){
                tempClipForm.tags.push("Penalty")
            }
            setLoadError({error: true, message: "Your clip will be created shortly"});
            await createClip(tempClipForm);
            setFormClip(defaultFormClip)
            setLoadError({error: true, message: "Clip created successfully"});
            setClipCreation(false)
            loadInfo()
        }catch(e){
            setLoadError({error: true, message: "Problems creating the clip"})
            console.error(e)
            setClipCreation(false)
        }
    }

    function isCreateClipDisabled(){
        if(trimPoints.length === 0){
            return true;
        }
        else if (trimPoints.length > 0 && (!trimPoints[0].start || !trimPoints[0].end)){
            return true;
        }
        return false
    }

    return (
        <> {event &&
            <Box width="100%"  sx={{ overflowX: 'hidden', overflowY: 'true' }}>
                <Typography variant="h4" color={theme.palette.white} gutterBottom display={'flex'} justifyContent={'start'}>
                    {event.name}  {formatUTCDate(event.start_schedule.toString())}
                </Typography>
                <Grid container spacing={2}>
                    <Grid item md={3} lg={2} xs={12}><Box
                        display="flex"
                        justifyContent="start"
                        sx={{
                            flexDirection: "column",
                            overflowY: "auto",
                            overflowX: "hidden",
                            paddingRight: 1,
                            height: "100%",
                            minHeight: "50vh",
                            maxHeight: playerBoxRef.current ? playerBoxRef.current.clientHeight : '70vh'
                        }}
                    >
                            <KeyMomentViewer
                                clips={clips}
                                handleChangeClip={handleChangeClip}
                                clipSelected={clipSelected}
                            />
                    </Box>
                    </Grid>
                    <Grid item md={6} lg={6.5} xs={12}>
                        <Box ref={playerBoxRef}>
                            <Box sx={{ overflowY: 'hidden'}}>
                                <KeyMomentWindowsPlayer
                                    url={eventStream.m3u8_signed_url}
                                    setVideoDuration={setVideoDuration}
                                    setVideoTime={setVideoTime}
                                    changeVideoTime={changeVideoTime}
                                    isPlaying={isPlaying}
                                    muted={muted}
                                    isActiveTime={isActiveTime}
                                    currentFocusElement={currentFocus}
                                    setIsPlaying={setIsPlaying}
                                    moveTrimPoint={moveTrimPoints}
                                    trimPoints={trimPoints}
                                    shortcuts={true}
                                    aspectRatio={aspectRatio}
                                    live = {live}
                                    dispose={dispose}
                                />
                            </Box>
                            <Box width={'100%'} marginTop={theme.spacing.md}>
                                <KeyMomentVideoPlayerBar
                                    setCurrentFocus={setCurrentFocus}
                                    deleteMode={false}
                                    onBlur={resetFocus}
                                    trimPoints={trimPoints}
                                    totalVideoTime={videoDuration}
                                    setVideoCurrentDuration={updateCurrentTime}
                                    videoCurrentTime={videoTime}
                                    onDeleteGrabber={deleteTrimPoint}
                                    setIsGrabberDragging={setIsGrabberDragging}
                                    updateTrimPoint={updateTrimPoints}
                                    mergeTrimPoints={mergeTrimPoints}
                                />
                            </Box>
                            <Box width={'100%'} marginTop={theme.spacing.md}>
                                <KeyMomentVideoPlayerControls
                                    videoTime={videoTime}
                                    onFocus={changeFocusNoShortCut}
                                    onBlur={resetFocus}
                                    isPlaying={isPlaying}
                                    muted={muted}
                                    onMute={(muted) => setMuted(muted)}
                                    onPlay={onVideoPlay} onPause={() => setIsPlaying(false)}
                                    onReset={reset} onDone={downloadClip}
                                    onSkip={(amount) => handleSkip(amount, 1)}
                                    onRewind={(amount) => handleSkip(amount, -1)}
                                    isWindowUpdating={false}
                                />
                            </Box>
                            <TrimPointsFields
                                trimPoints={trimPoints}
                                restoreTrimPoints={restoreTrimPoints}
                                onChangeTrimPoints={handleChangeTrimPoints}
                                onSetTrimPoints={onSetTrimPointsToVideoTime}
                                resetTrimPoints={resetTrimPoints}
                                disableRestoreTrimPoints={clipSelected === undefined}
                                disableSetTrimPoints={!videoDuration}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={3.5}>
                        <ClipForm
                            clip={formClip}
                            clipId={clipSelected}
                            onFieldChange={onClipFormFieldChange}
                            onSubmit={onClipFormSubmit}
                            teamOptions={teamOptions}
                            periodOptions={periodOptions}
                            keyMomentOptions={keyMomentOptions}
                            disableSubmitButton={isCreateClipDisabled() || clipCreation}
                        />
                    </Grid>
                </Grid>

            <ErrorSnackBar
                autoHideDuration={5000}
                open={loadError.error}
                setClose={() => setLoadError({ message: '', error: false })}
                errorMessage={loadError.message}
            />
            </Box>
         }
        </>
    );

}